<template>
    <div>
        <v-tabs
                v-model="active"
                color="secondary"
                dark
                slider-color="primary"
        >
            <v-tab ripple>
                Distribution
            </v-tab>
            <v-tab-item>
                <v-layout wrap row>
                    <v-flex xs12 sm12 ma-2>

                        <v-btn class="secondary white--text" @click.stop="">
                            WIDGET
                            <v-icon class="white--text" right>add</v-icon>
                        </v-btn>
                    </v-flex>

                </v-layout>

                <v-layout wrap row>
                    <v-flex xs12 sm6 md4 ma-0>
                        <v-card class="dashboard-chart">
                            <v-card-title>Inquiries</v-card-title>
                           <!--:colors="['#1c2d62', '#9c9026' ,'#e2d628' , '#3d5dd1']"-->
                            <area-chart :library="options" :discrete="true" legend="bottom"
                                        :data="lineData"></area-chart>
                        </v-card>
                    </v-flex>

                    <v-flex xs12 sm6 md4 ma-0>
                        <v-card class="dashboard-chart">
                            <v-card-title>Offers</v-card-title>
                            <!--:colors="['#1c2d62', '#9c9026']" :donut="true"-->
                            <pie-chart :library="options" :discrete="true" legend="bottom"
                                       :data="pieData"></pie-chart>
                        </v-card>
                    </v-flex>


                    <v-flex xs12 sm6 md4 ma-0>
                        <v-card class="dashboard-chart">
                            <v-card-title>Sales</v-card-title>
                           <!-- :colors="['#1c2d62', '#9c9026' ,'#9c5026' ,'#1c5926']"-->
                            <column-chart :library="options" :discrete="true" legend="bottom" thousands="." prefix="€"
                                          :data="barData"></column-chart>
                        </v-card>
                    </v-flex>


                </v-layout>
            </v-tab-item>

            <v-tab ripple>
                Logistics
            </v-tab>
            <v-tab-item>
                <v-layout row>
                    <v-flex xs12 sm3>
                        <v-card flat>
                            <div>Logistics</div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-tab-item>

            <v-tab ripple>
                Accounting
            </v-tab>
            <v-tab-item>
                <v-layout row>
                    <v-flex xs12 sm3>
                        <v-card flat>
                            <div>Accounting</div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-tab-item>


        </v-tabs>
    </div>
</template>

<script>
    import {
        Dashboard
    } from '../store/namespace-helper'

    import {stateHelperMixin} from '../mixins/stateHelperMixin'

    export default {
      name: 'dashboard',
      mixins: [stateHelperMixin],
      data () {
        return {
          active: 0,
          line: null,
          pie: null,
          bar: null,
          options: {
            animation: {
              duration: 1250,
                        /* easing: "linear", */
              onProgress: function (animation) {
                            // progress.value = animation.animationObject.currentStep / animation.animationObject.numSteps;
                            // console.log("progress!!!")
              }
            }
          }
        }
      },
      methods: {},
      computed: {
        lineData () {
          return this.$store.getters[Dashboard.getters.getWeeklyInquiriesStat]
        },
        pieData () {
          return this.pie
        },
        barData () {
          return this.bar
        }
      },
      watch: {},
      beforeDestroy () {
        this.resetStateBeforeLeaveRoute()
      },
      mounted () {
        this.$store.dispatch(Dashboard.actions.loadWeeklyInquiresStats)

/*        setTimeout(() => {
          this.line = [
                    {name: 'Team1', data: {'2017-05-13': 2, '2017-06-14': 10, '2017-07-13': 12, '2017-8-14': 11}},
                    {name: 'Team2', data: {'2017-05-13': 4, '2017-06-14': 15, '2017-07-13': 20, '2017-8-14': 19}},
                    {name: 'Team3', data: {'2017-05-13': 11, '2017-06-14': 20, '2017-07-13': 5, '2017-8-14': 10}}
          ]
        }, 450) */

        this.pie = [['Waiting', 75], ['Finished', 123]]

/*        setTimeout(() => {

        }, 450) */

        this.bar = [
          {
            name: 'Team1',
            data: [['Sun', 32000], ['Mon', 46200], ['Tue', 28000], ['Wed', 31000], ['Thu', 45000]]
          },
          {
            name: 'Team2',
            data: [['Sun', 48000], ['Mon', 26200], ['Tue', 59000], ['Wed', 11000], ['Thu', 110000]]
          }

        ]
    
/*        setTimeout(() => {

        }, 450) */
      }
    }
</script>

<style scoped>

    .dashboard-chart {
        padding: 16px;
        margin: 8px;
    }


</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue